import { render } from "./CatchmentView.vue?vue&type=template&id=8b0d65c0"
import script from "./CatchmentView.vue?vue&type=script&lang=js"
export * from "./CatchmentView.vue?vue&type=script&lang=js"

import "./CatchmentView.vue?vue&type=style&index=0&id=8b0d65c0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__